import { useModel } from '@umijs/max';
import { useEffect } from 'react';
import { registerInitialStateSetter } from '@/utils/initialStateUser';

/** 向非 React 模块（如 request 拦截器）暴露 setInitialState */
const InitialStateBinder = () => {
  const { setInitialState } = useModel('@@initialState');

  useEffect(() => {
    registerInitialStateSetter(
      setInitialState as Parameters<typeof registerInitialStateSetter>[0],
    );
    return () => registerInitialStateSetter(null);
  }, [setInitialState]);

  return null;
};

export default InitialStateBinder;
